const noteAudioMap = {
    'g': require('../audio/G3.mp3'),
    'af': require('../audio/Ab3.mp3'),
    'a': require('../audio/A3.mp3'),
    'bf': require('../audio/Bb3.mp3'),
    'b': require('../audio/B3.mp3'),
    'c': require('../audio/C4.mp3'),
    'df': require('../audio/Db4.mp3'),
    'd': require('../audio/D4.mp3'),
}

export {noteAudioMap}